import Trip from "../../model/Trip";
import { dstCalculator, getStartOfDayUserTimezone } from "../date";
import { getServerDate } from "../storage/date";
import { hashToArray, isEmpty } from "../vanilla";

export function getStartOfDayFrom(daysBack: number) {
    let serverDate = getServerDate();

    let fromDate = new Date(serverDate.getTime());
    fromDate.setUTCDate(fromDate.getUTCDate() - daysBack);

    // Get offsets difference between initial date (serverDate) and fromDate
    let startOffset = dstCalculator.getOffset(serverDate) - dstCalculator.getOffset(fromDate);
    let localStartOffset = serverDate.getTimezoneOffset() - fromDate.getTimezoneOffset();
    fromDate.setUTCMinutes(fromDate.getUTCMinutes() + startOffset - localStartOffset);

    return getStartOfDayUserTimezone(fromDate);
}

export function getTripsForLastTwoDays(tripsDict: IIdDictionary<IIdDictionary<Trip>>) {
    let filteredTrips: IIdDictionary<IIdDictionary<Trip>> = {};
    let fromDate = getStartOfDayFrom(2);

    Object.keys(tripsDict).forEach(userId => {
        let userTrips = tripsDict[userId];
        let filteredUserTrips = {};
        if (userTrips && !isEmpty(userTrips)) {
            hashToArray(userTrips).forEach((trip: Trip) => {
                if (typeof trip.start !== "undefined" && trip.start >= fromDate.toISOString()) {
                    filteredUserTrips[trip.id] = trip;
                }
            });
        }
        filteredTrips[userId] = filteredUserTrips;
    });
    return filteredTrips;
}

/**
 * Get a list of devices the user has trips with in the provided time range
 * @param fromDate The start date of the period we want to look up trips
 * @param toDate The end date of the period we want to look up the trips
 * @param trips A dictionary of trips to find unique devices
 * @returns A list of device IDs
 */
 export function getDeviceIdsFromTrips(fromDate: string, toDate: string, trips: IIdDictionary<Trip>) {
    if (trips) {
        return Array.from(new Set(hashToArray(trips)
            .filter(trip => {
                if (trip.start && (trip.start >= fromDate && trip.start <= toDate)
                || (trip.stop && (trip.stop >= fromDate && trip.stop <= toDate))) {
                    return true;
                }
                return false;
            })
            .map(trip => trip.device.id)));
    }
    return [];
}